import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
import TtyIcon from "@mui/icons-material/Tty";
import DevicesOtherIcon from "@mui/icons-material/DevicesOther";
import PermPhoneMsgIcon from "@mui/icons-material/PermPhoneMsg";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CallSplitIcon from "@mui/icons-material/CallSplit";
import ServerStatusIcon from "@mui/icons-material/Dns";
import SuccsesIcon from "@mui/icons-material/Call";
import FailedIcon from "@mui/icons-material/CallEnd";
import CarrierCallsIcon from "@mui/icons-material/AddIcCall";
import ActiveCallsIcon from "@mui/icons-material/PermPhoneMsg";
import SendIcon from "@mui/icons-material/Send";
import InboxIcon from "@mui/icons-material/Inbox";
import EmailIcon from "@mui/icons-material/Email";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import GridViewRoundedIcon from "@mui/icons-material/GridViewRounded";
import GroupsRoundedIcon from "@mui/icons-material/GroupsRounded";
import SubtitlesOutlinedIcon from "@mui/icons-material/SubtitlesOutlined";
import GridViewOutlinedIcon from "@mui/icons-material/GridViewOutlined";
import SupportAgentOutlinedIcon from "@mui/icons-material/SupportAgentOutlined";
import TextSnippetOutlinedIcon from "@mui/icons-material/TextSnippetOutlined";
import SipOutlinedIcon from "@mui/icons-material/SipOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import GradingOutlinedIcon from "@mui/icons-material/GradingOutlined";
import AudioFileIcon from "@mui/icons-material/AudioFile";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import AppBlockingIcon from "@mui/icons-material/AppBlocking";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import BusinessIcon from "@mui/icons-material/Business";
import DialpadIcon from "@mui/icons-material/Dialpad";
import ContactsIcon from "@mui/icons-material/Contacts";
export const LeftMenuItems = {
  control: [
    {
      item: "users",
      path: "control/users",
      displayName: "Users",
      icon: <ManageAccountsIcon />,
      permission: "",
    },
    {
      item: "groups",
      path: "control/groups/id/tab",
      displayName: "Groups",
      icon: <Diversity3Icon />,
      permission: "",
    },
    // {
    //     item: 'queues',
    //     path: "control/queues/id/tab",
    //     displayName: 'Queues',
    //     icon: <QueuePlayNextIcon />,
    //     permission: ''
    // },
    {
      item: "ivr",
      path: "control/ivr/edit",
      displayName: "IVR",
      icon: <CallSplitIcon />,
      permission: "",
    },
    {
      item: "officehours",
      path: "control/office_hours/id",
      displayName: "Office Hours",
      icon: <AccessTimeIcon />,
      permission: "",
    },
    {
      item: "number",
      path: "control/number/edit",
      displayName: "MainNumber",
      icon: <RecordVoiceOverIcon />,
      permission: "",
    },
    {
      item: "calllogs",
      path: "control/calllogs/edit",
      displayName: "CallLogs",
      icon: <TtyIcon />,
      permission: "",
    },
    {
      item: "SIP Accounts",
      path: "control/sip_accounts",
      displayName: "SIP Accounts",
      icon: <SipOutlinedIcon />,
      permission: "",
    },
    {
      item: "Cell Phones",
      path: "control/cell_phones",
      displayName: "Cell Phones",
      icon: <DevicesOtherIcon />,
      permission: "",
    },
    {
      item: "voicemail",
      path: "control/voicemail",
      displayName: "VoiceMail",
      icon: <PermPhoneMsgIcon />,
      permission: "",
    },
    // {
    //     item: 'paging',
    //     path: "control/paging",
    //     displayName: 'Paging',
    //     icon: <AutoStoriesOutlinedIcon />,
    //     permission: ''

    // }
  ],
  userapp: [
    {
      item: "users",
      path: "userapp/users",
      displayName: "Users",
      icon: <ManageAccountsIcon />,
      permission: "",
    },
    {
      item: "groups",
      path: "userapp/groups/id/tab",
      displayName: "Groups",
      icon: <Diversity3Icon />,
      permission: "",
    },
    // {
    //     item: 'queues',
    //     path: "userapp/queues/id/tab",
    //     displayName: 'Queues',
    //     icon: <QueuePlayNextIcon />,
    //     permission: ''
    // },
    {
      item: "ivr",
      path: "userapp/ivr/edit",
      displayName: "IVR",
      icon: <CallSplitIcon />,
      permission: "",
    },
    {
      item: "officehours",
      path: "userapp/office_hours/id",
      displayName: "Office Hours",
      icon: <AccessTimeIcon />,
      permission: "",
    },
    {
      item: "number",
      path: "userapp/number/edit",
      displayName: "MainNumber",
      icon: <RecordVoiceOverIcon />,
      permission: "",
    },
    {
      item: "calllogs",
      path: "userapp/calllogs/edit",
      displayName: "CallLogs",
      icon: <TtyIcon />,
      permission: "",
    },
    {
      item: "SIP Accounts",
      path: "userapp/sip_accounts",
      displayName: "SIP Accounts",
      icon: <SipOutlinedIcon />,
      permission: "",
    },
    {
      item: "Cell Phones",
      path: "userapp/cell_phones",
      displayName: "Cell Phones",
      icon: <DevicesOtherIcon />,
      permission: "",
    },
    {
      item: "voicemail",
      path: "userapp/voicemail",
      displayName: "VoiceMail",
      icon: <PermPhoneMsgIcon />,
      permission: "",
    },
    // {
    //     item: 'paging',
    //     path: "userapp/paging",
    //     displayName: 'Paging',
    //     icon: <AutoStoriesOutlinedIcon />,
    //     permission: ''

    // }
  ],
  system: [
    {
      item: "server",
      path: "system/server/:key",
      displayName: "Server Status",
      icon: <ServerStatusIcon />,
      permission: "",
    },
    {
      item: "success_calls",
      path: "system/success_calls",
      displayName: "Success Calls",
      icon: <SuccsesIcon />,
      permission: "",
    },
    {
      item: "carrier_calls",
      path: "system/carrier_calls",
      displayName: "Carrier Calls",
      icon: <CarrierCallsIcon />,
      permission: "",
    },
    {
      item: "failed_calls",
      path: "system/failed_calls",
      displayName: "Failed Calls",
      icon: <FailedIcon />,
      permission: "",
    },
    {
      item: "active_calls",
      path: "system/active_calls",
      displayName: "Active Calls",
      icon: <ActiveCallsIcon />,
      permission: "",
    },
  ],
  fax: [
    {
      item: "composefax",
      path: "fax/compose_fax",
      displayName: "Compose Fax",
      icon: <SendIcon />,
      permission: "",
    },
    {
      item: "inboundfax",
      path: "fax/inbound_fax",
      displayName: "Inbound Fax",
      icon: <InboxIcon />,
      permission: "",
    },
    {
      item: "outboundfax",
      path: "fax/outbound_fax",
      displayName: "Outbound Fax",
      icon: <EmailIcon />,
      permission: "",
    },
    // {
    //     item: 'emailtofaxes',
    //     path: "fax/emailtofaxes",
    //     displayName: 'Email To Faxes',
    //     icon: <OutboxIcon />,
    //     permission: ''
    // }
  ],
  settings: [
    {
      item: "general",
      path: "settings/general",
      displayName: "General Settings",
      icon: <ToggleOnIcon />,
      permission: "",
    },
    {
      item: "featurecode",
      path: "settings/feature_code",
      displayName: "Feature Code ",
      icon: <GradingOutlinedIcon />,
      permission: "",
    },
    {
      item: "audiolibrary",
      path: "settings/audio_library",
      displayName: "Audio Library",
      icon: <AudioFileIcon />,
      permission: "",
    },
    {
      item: "emailnotifications",
      path: "settings/email_notifications",
      displayName: "Email Notifications",
      icon: <NotificationsActiveIcon />,
      permission: "",
    },
    {
      item: "blockednumbers",
      path: "settings/blocked_numbers",
      displayName: "Blocked Numbers",
      icon: <AppBlockingIcon />,
      permission: "",
    },
  ],
  supervisor: [
    {
      item: "queues",
      path: "supervisor/queues",
      displayName: "Queues ",
      icon: <GroupsRoundedIcon />,
      permission: "",
    },
    {
      item: "wallboard",
      path: "supervisor/wallboard",
      displayName: "Wallboard",
      icon: <GridViewRoundedIcon />,
      permission: "",
    },

    {
      item: "livequeuestatus",
      path: "supervisor/live_queue_status",
      displayName: "Live Queue Status",
      icon: <SubtitlesOutlinedIcon />,
      permission: "",
    },
    // {
    //     item: 'liveagentstatus',
    //     path: "supervisor/live_agent_status",
    //     displayName: 'Live Agent Status',
    //     icon: <SupportAgentOutlinedIcon />,
    //     permission: ''
    // },
    {
      item: "reports",
      path: "supervisor/reports/queues",
      displayName: "Reports",
      icon: <DescriptionOutlinedIcon />,
      permission: "",
      subItems: [
        {
          item: "queues",
          displayName: "Queues",
          path: "supervisor/reports/queues",
          icon: <GroupsOutlinedIcon />,
          subItems: [
            {
              item: "dashboard",
              path: "supervisor/reports/queues",
              displayName: "Dashboard",
            },
            {
              item: "queueavgwaitandtalktime",
              path: "supervisor/reports/queues/queue_avg_wait_and_talk_time",
              displayName: "Queue Avg Wait And Talk Time",
            },
            {
              item: "queueperformancereport",
              path: "supervisor/reports/queues/queue_performance_report",
              displayName: "Queue Performance Report",
            },
            {
              item: "sla",
              path: "supervisor/reports/queues/sla",
              displayName: "SLA",
            },
            // {
            //     item: "queuecallbacksummaryreport",
            //     path: "supervisor/reports/queues/queue_callback_summary_report",
            //     displayName: "Queue Callback Summary "
            // },
            // {
            //     item: "satisfactionsurveyreport",
            //     path: "supervisor/reports/queues/satisfaction_survey_report",
            //     displayName: "Satisfaction Survey "
            // },
          ],
        },
        {
          item: "agents",
          displayName: "Agents",
          path: "supervisor/reports/agents",
          icon: <SupportAgentIcon />,
          subItems: [
            {
              item: "dashboard",
              path: "supervisor/reports/agents",
              displayName: "Dashboard",
            },
            {
              item: "agentcallsummaryreport",
              path: "supervisor/reports/agents/agent_call_summary_report",
              displayName: "Agent Call Summary Report",
            },
            {
              item: "agentperformancereport",
              path: "supervisor/reports/agents/agent_performance_report",
              displayName: "Agent Performance Report",
            },

            {
              item: "agentmissedcallactivityreport",
              path: "supervisor/reports/agents/agent_missed_call_activity_report",
              displayName: "Agent Missed Call Activity Report",
            },
          ],
        },
      ],
    },
  ],
  agent: [
    {
      item: "controlpanel",
      path: "agent/controlpanel",
      displayName: "ACP",
      icon: <GridViewOutlinedIcon />,
      permission: "",
    },
    {
      item: "reports",
      path: "agent/reports",
      displayName: "Reports ",
      icon: <DescriptionOutlinedIcon />,
      permission: "",
      subItems: [
        {
          item: "agents",
          displayName: "My Reports",
          path: "agent/reports/",
          icon: <SupportAgentIcon />,
          subItems: [
            {
              item: "dashboard",
              path: "agent/reports/",
              displayName: "Dashboard",
            },
            {
              item: "agentcallsummaryreport",
              path: "agent/reports/my_call_summary_report",
              displayName: "My Call Summary Report",
            },
            {
              item: "agentperformancereport",
              path: "agent/reports/my_performance_report",
              displayName: "My Performance Report",
            },
            {
              item: "agentmissedcallactivityreport",
              path: "agent/reports/my_missed_call_activity_report",
              displayName: "My Missed Call Activity Report",
            },
          ],
        },
      ],
    },
    {
      item: "settings",
      path: "agent/settings",
      displayName: "Settings ",
      icon: <SupportAgentOutlinedIcon />,
      permission: "",
    },
  ],
  address: [
    {
      item: "company",
      path: "address/company",
      displayName: "Company",
      icon: <BusinessIcon />,
      permission: "",
    },
    {
      item: "books",
      path: "address/books",
      displayName: "Address Books ",
      icon: <ContactsIcon />,
      permission: "",
    },
    // {
    //   item: "speeddial",
    //   path: "address/speed_dial",
    //   displayName: "Speed Dial",
    //   icon: <DialpadIcon />,
    //   permission: "",
    // },
  ],
};
